import React from "react";

const NodeContainer = ({ data, children, selected }) => {
  return (
    <div
      style={{
        borderRadius: "6px",
        border: selected ? "1px solid #ddd" : "none",
        padding: "8px",
        backgroundColor: "white",
        color: "primary.contrastText",
        minWidth: 220,
        position: "relative",
      }}
    >
      {children}
    </div>
  );
};

export default NodeContainer;
